<template>
    <dropdown
        ref="dropdown"
        class="site-header__contact"
        hover="small"
        :align="align"
        data-navigation="Contact Us"
    >
        <slot></slot>
    </dropdown>
</template>

<script>
    let contactMenuCount = 0;

    export default {
        data() {
            contactMenuCount += 1;
            return {
                menuId: `site-header-contact-menu-${contactMenuCount}`,
            };
        },
        props: {
            align: {
                required: false,
                default: '',
            },
        },
        mounted() {
            const dropdown = this.$refs.dropdown;
            this.menuToggle = this.$el.querySelector(':scope > .site-header__contact-menu-toggle');
            this.menuContent = this.$el.querySelector(':scope > .v-dropdown-content');

            if (this.menuContent) {
                this.menuContent.id = this.menuId;
            }

            if (!dropdown || !this.menuToggle) {
                return;
            }

            this.syncMenuToggle();

            this.unwatchExpanded = dropdown.$watch('expanded', this.syncMenuToggle);

            this.menuToggle.addEventListener('click', this.handleToggleClick);

            this.$el.addEventListener('keydown', this.handleMenuKeydown, true);
            this.$el.addEventListener('focusout', this.handleMenuFocusOut);
        },
        beforeDestroy() {
            if (this.unwatchExpanded) {
                this.unwatchExpanded();
            }
            if (this.menuToggle) {
                this.menuToggle.removeEventListener('click', this.handleToggleClick);
            }
            this.$el.removeEventListener('keydown', this.handleMenuKeydown, true);
            this.$el.removeEventListener('focusout', this.handleMenuFocusOut);
        },
        methods: {
            syncMenuToggle() {
                if (!this.menuToggle) {
                    return;
                }
                this.menuToggle.setAttribute('aria-expanded', this.menuIsOpen() ? 'true' : 'false');
                this.menuToggle.setAttribute('aria-controls', this.menuId);
            },
            handleToggleClick(e) {
                e.stopPropagation();
                this.toggleMenu();
            },
            menuIsOpen() {
                return Boolean(this.$refs.dropdown && this.$refs.dropdown.expanded);
            },
            openMenu() {
                if (this.$refs.dropdown) {
                    this.$refs.dropdown.show();
                }
            },
            closeMenu(focusToggle = false) {
                if (this.$refs.dropdown) {
                    this.$refs.dropdown.onOut();
                }
                if (focusToggle && this.menuToggle) {
                    this.menuToggle.focus();
                }
            },
            toggleMenu() {
                if (this.menuIsOpen()) {
                    this.closeMenu();
                } else {
                    this.openMenu();
                }
            },
            focusFirstMenuItem() {
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        const content = this.$el.querySelector('.v-dropdown-content');
                        const items = content ? content.querySelectorAll('a[href], button:not([disabled])') : [];
                        const firstItem = Array.from(items).find(item => item.getClientRects().length > 0);
                        if (firstItem) {
                            firstItem.focus();
                        }
                    });
                });
            },
            handleMenuKeydown(e) {
                const onToggle = e.target === this.menuToggle;
                const onContactLink = e.target === this.$el.querySelector(':scope > .v-dropdown-toggle');

                if (e.key === 'Escape') {
                    if (!this.menuIsOpen()) {
                        return;
                    }
                    e.preventDefault();
                    e.stopPropagation();
                    this.closeMenu(true);
                    return;
                }

                if (!onToggle && !onContactLink) {
                    return;
                }

                if (onToggle && (e.key === 'Enter' || e.key === ' ')) {
                    e.stopPropagation();
                    return;
                }

                if (e.key === 'ArrowDown' || (onContactLink && e.key === ' ')) {
                    e.preventDefault();
                    this.openMenu();
                    this.focusFirstMenuItem();
                    return;
                }

                if (e.key === 'Tab' && !e.shiftKey) {
                    if (onContactLink && this.menuToggle) {
                        e.preventDefault();
                        this.menuToggle.focus();
                    } else if (onToggle && this.menuIsOpen()) {
                        e.preventDefault();
                        e.stopPropagation();
                        this.focusFirstMenuItem();
                    }
                }
            },
            handleMenuFocusOut(e) {
                if (!this.menuIsOpen() || (e.relatedTarget && this.$el.contains(e.relatedTarget))) {
                    return;
                }
                if (this.$el.matches(':hover')) {
                    return;
                }
                this.closeMenu();
            },
        },
    };
</script>
